export default {
  logo: "/assets/westfield/logo.png",
  logo_lg_pdf: "/assets/westfield/logo-new.png",
  logo_pdf: "/assets/westfield/logo-pdf.png",
  footer_pdf: "/assets/westfield/footer.jpg",
  landing: {
    default: "/assets/thq/landing/index.jpg",
  },
};
